import {
  StyledSessionList,
  SessionListControls,
  SessionListContent,
  SessionListHint,
  InternalSessionInfo,
  InternalSession,
  InternalSessionList,
  InternalSessionListWrapper,
  Checkmark,
  PopupTopDecorator
} from './VsBattlePopup.styled';
import { useAudio } from '../../providers/AudioContext';
import { PopupHeader, BroadsiderHudPopup, IconButton } from '../';
import { useContext, useEffect, useState, useCallback } from 'react';
import { AppContext } from '../../providers/AppContext';
import { AuthContext } from '../../providers/AuthProvider';
import { useWebSocket } from '../../hooks';

const SESSION_STATE_CHECK_TIMEOUT_MS = 3000;

const SessionListData = ({ onSelectSession, user, selectedSession, sessions }) => {
  const { playSFX } = useAudio();
  return (
    <InternalSessionList>
      <InternalSessionListWrapper>
        {sessions.map((s, index) => {
           const hostPlayer = s.players[0];
           const isOwn = user.email === hostPlayer.email;
           return (
             <InternalSession key={s.host_id} $own={isOwn} $selected={s.host_id === selectedSession?.host_id} onClick={() => onSelectSession(s)} onMouseEnter={() => isOwn ? false : playSFX('hover')}>
               <InternalSessionInfo >{isOwn ? 'You' : hostPlayer.user_name}</InternalSessionInfo>
               {s.host_id === selectedSession?.host_id && <Checkmark src='/assets/done.svg'/>}
             </InternalSession>
           );
        })}
      </InternalSessionListWrapper>
    </InternalSessionList>
  );
};

const VsBattlePopup = ({ onGameStarted, onSelectOpponent, disabled }) => {
  const [selectedSession, setSelectedSession] = useState(null);
  const [joinedSession, setJoinedSession] = useState(null);
  const { selectedBroadsider, currentUserEmail } = useContext(AppContext);
  const { basejumpToken: basejumpAccessToken, user } = useContext(AuthContext);
  const [sessions, setSessions] = useState([]);
  const { isConnected: wsIsConnected, lastMessage, error: wsError, sendMessage } = useWebSocket();
  const { playSFX } = useAudio();

  const matchAdded = useCallback((data) => {
    const newSessions = sessions.filter(s => s.host_id !== data.host_id);
    setSessions([...newSessions, data]);
  }, [sessions]);

  const matchesList = useCallback((data) => {
    setSessions(data);
    if (!data.find(s => selectedSession?.id === s.id)) {
      onSelectSession(null);
    }
  }, [sessions]);

  const matchRemoved = useCallback((data) => {
    const newSessions = sessions.filter(s => s.host_id !== data.host_id);
    if (data.id === selectedSession?.id) {
      onSelectSession(null);
    }
    setSessions(newSessions);
  }, [sessions]);

  useEffect(() => {
    if (lastMessage) {
      switch (lastMessage.type) {
        case 'matches_list':
          matchesList(lastMessage.data);
          break;
        case 'match_added':
          matchAdded(lastMessage.data);
          break;
        case 'match_removed':
          matchRemoved(lastMessage.data);
          break;
        default:
	  console.error(JSON.stringify(lastMessage));
          break;
      }
    }
  }, [lastMessage]);

  const fetchSessions = () => {
    sendMessage({ type: 'list_matches' });
  };

  const onSelectSession = (session) => {
    setSelectedSession(session);
    onSelectOpponent(session?.avatars[0]);
    if (session) {
      playSFX('menu_button');
    }
  };

  const createSession = (cancel = false) => {
    onSelectSession(null);
    if (cancel) {
      sendMessage({ type: 'remove_match' });
    } else {
      sendMessage({ type: 'add_match', data: { avatarId: selectedBroadsider.getAvatarId()} });
    }
  };

  const joinSession = () => {
    sendMessage({ type: 'join_match', data: { avatarId: selectedBroadsider.getAvatarId(), hostId: selectedSession.host_id } });
  };

  useEffect(() => {
    fetchSessions();
    return () => createSession(true);
  }, []);

  const hasOwnSession = sessions.find(s => s.players[0].email === user.email);
  const battleDisabled = hasOwnSession || !selectedSession || !sessions.map((s) => s.host_id).includes(selectedSession.host_id);

  return (
    <BroadsiderHudPopup overwrightWidth='25vw' overwrightMinWidth='23rem'>
      <PopupTopDecorator/>
      <StyledSessionList>
        <PopupHeader title='Choose Opponent' />
        <SessionListContent>
	  <SessionListHint>
            Battle others to win XP, Bones and Action Items
          </SessionListHint>
          <SessionListData user={user} onSelectSession={(session) => hasOwnSession ? false : onSelectSession(session)} selectedSession={selectedSession} sessions={sessions}/>
          <SessionListControls>
            <IconButton disabled={battleDisabled || disabled} onClick={joinSession}>
              <div>Battle</div>
            </IconButton>
            <IconButton disabled={disabled} onClick={() => createSession(hasOwnSession)}>
              <div>{hasOwnSession ? 'Cancel' : 'Create Game'}</div>
            </IconButton>
          </SessionListControls>
        </SessionListContent>
      </StyledSessionList>
    </BroadsiderHudPopup>
  );
};

export default VsBattlePopup;
